import type { ReactNode } from 'react';
import { closeDetail } from '../store/appStore';

/**
 * Frame for every detail view in the panel: a header with the view title and a
 * Done button (iOS presents these as sheets with a Done toolbar item), then a
 * scrolling body.
 */
export function DetailShell({ title, children, headerExtra }: { title: string; children: ReactNode; headerExtra?: ReactNode }) {
  return (
    <div className="detail-shell">
      <header className="detail-header">
        <button type="button" className="btn btn-ghost detail-back" onClick={closeDetail} aria-label="Back to search">
          <span aria-hidden="true">‹</span> Back
        </button>
        <h2 className="detail-title">{title}</h2>
        <div className="detail-header-extra">{headerExtra}</div>
        <button type="button" className="btn btn-primary detail-done" onClick={closeDetail}>
          Done
        </button>
      </header>
      <div className="detail-body">{children}</div>
    </div>
  );
}
